import { DecimalField, Form } from '@ff-it/form';
import { Button, Popover, PopoverRef, Stack } from '@ff-it/ui';
import { ReactElement, useRef } from 'react';
import { required } from 'utilities';

type SeekButtonProps = {
  seekBudgetQuantity: (values: { budget: string }) => void;
};

export function SeekButton({ seekBudgetQuantity }: SeekButtonProps): ReactElement {
  const ref = useRef<PopoverRef>(null);
  return (
    <Popover
      ref={ref}
      interaction="click"
      placement="bottom-start"
      content={
        <Form<{ budget: string }>
          onSubmit={(values) => {
            seekBudgetQuantity(values);
            ref.current?.setIsOpen(false);
          }}
          autoComplete="off"
        >
          <Stack direction="horizontal" p="2">
            <DecimalField name="budget" placeholder="Budget" required validate={required} className="mb-0" />
            <Button type="submit" testId="goal-seek-submit">
              Goal seek qauntity
            </Button>
          </Stack>
        </Form>
      }
    >
      <Button variant="ghost" icon="bullseye-arrow" size="xs" testId="goal-seek" />
    </Popover>
  );
}
